// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"style_tooltipIcon__olz7w"};